import I18n from "i18n-js";
import en from "./locales/en";

I18n.fallbacks = true;
I18n.locale = "en";

I18n.translations = {
  en
};

export default I18n;
